import {
  EntityTypeEnum,
  InterviewRequestSourceEnum,
  OperationTypeEnum
} from "@rooster/types";
import { recordTermsAcceptance } from "../../services/api/termsacceptance.api";
import { LegalType } from "../../types";
import { buildAcceptedTerms } from "./buildTermsAcceptance";

export interface RecordTermsAcceptanceIfApplicableArgs {
  clientId: string;
  requestType: InterviewRequestSourceEnum;
  operationType: OperationTypeEnum;
  entityType: EntityTypeEnum;
  entityId: string;
  meetingLinkId?: string;
  trackingId: string;
  legal: LegalType[];
  selectedLanguages: Record<string, string>;
}

/**
 * Awaited wrapper. Skips silently when there are no terms to record.
 * The underlying `recordTermsAcceptance` resolves even on network failure,
 * so this helper never throws and never blocks the caller's success path.
 */
export const recordTermsAcceptanceIfApplicable = async (
  args: RecordTermsAcceptanceIfApplicableArgs
): Promise<void> => {
  if (!args.legal || args.legal.length === 0) {
    return;
  }
  const acceptedTerms = buildAcceptedTerms(args.legal, args.selectedLanguages);
  if (acceptedTerms.length === 0) {
    // Surface this case to operators: legal docs were present and shown to
    // the candidate but produced no acceptedTerms entries. Without a log
    // here this gap is invisible in production.
    console.warn(
      "[recordTermsAcceptanceIfApplicable] buildAcceptedTerms returned empty — no record written",
      { legalCount: args.legal.length }
    );
    return;
  }
  await recordTermsAcceptance({
    clientId: args.clientId,
    requestType: args.requestType,
    operationType: args.operationType,
    entityType: args.entityType,
    entityId: args.entityId,
    meetingLinkId: args.meetingLinkId,
    trackingId: args.trackingId,
    acceptedTerms
  });
};
